/**
 * Bookmark management functionality
 * Uses ListManagement for shared edit mode and removal logic
 */
(function() {
    'use strict';

    // Helper to get translation (falls back to key if i18n not available)
    function t(key) {
        return window.t ? window.t(key) : key;
    }

    // Legacy function for backwards compatibility
    window["removeBookmark"] = function (item) {
        var url = $(item).attr('href')
        $.ajax({
            url: url,
            success: function (data) {
                $(item).closest('.bmProfBox').remove()
                var count = $("#bookmarkCount").text()
                count--
                $("#bookmarkCount").text(count)
            }
        });
    }

    // Modern bookmark deletion with modal
    document.addEventListener('DOMContentLoaded', function() {
        // Only initialize on bookmark pages
        if (!document.querySelector('[data-bookmarks-container]')) return;

        // Initialize edit mode toggle
        window.ListManagement.initEditMode({
            deleteButtonClass: 'bookmark-delete-btn'
        });

        // Delegate click events for delete buttons
        document.addEventListener('click', handleDeleteClick);
    });

    function handleDeleteClick(e) {
        var deleteBtn = e.target.closest('.bookmark-delete-btn');
        if (!deleteBtn) return;

        e.preventDefault();
        e.stopPropagation();

        var bookmarkId = deleteBtn.dataset.bookmarkId;
        var username = deleteBtn.dataset.bookmarkUsername;

        window.ListManagement.confirmAndRemove({
            title: t('common.remove_bookmark'),
            message: t('common.remove_bookmark_confirm').replace('{username}', username),
            fallbackMessage: t('common.remove_bookmark_fallback').replace('{username}', username),
            onConfirm: function() {
                removeBookmarkModern(deleteBtn, bookmarkId);
            }
        });
    }

    function removeBookmarkModern(button, bookmarkId) {
        var card = button.closest('[data-bookmark-card]');

        window.ListManagement.removeItem({
            button: button,
            card: card,
            url: '/app/bookmarks/remove',
            formData: { bookmark: bookmarkId },
            errorMessage: t('common.remove_bookmark_error'),
            logPrefix: 'Bookmark removal',
            onSuccess: updateBookmarkCount
        });
    }

    function updateBookmarkCount() {
        var container = document.querySelector('[data-bookmarks-container]');
        if (!container) return;

        var remaining = container.querySelectorAll('[data-bookmark-card]').length;

        if (remaining === 0) {
            // Clone empty state from hidden template
            var template = document.getElementById('bookmarks-empty-state');
            if (template) {
                var emptyState = template.content.cloneNode(true);
                container.parentNode.replaceChild(emptyState, container);
                // Initialize Lucide icons in the new empty state
                if (window.LucideIcons) {
                    window.LucideIcons.initialize();
                }
            }
        }
    }
})();
